import BaseQuery from "../common/BaseQuery";

export default class QuizParams extends BaseQuery {
    static get(regCode, event_id, lang, successCb, errCb) {

        let params = {
            p: 'api',
            op: 'quiz',
            lang: !!lang ? lang : 'ru',
            event_id: event_id,
            id: regCode
        };

        // ---------------- TEST DATA
        // successCb(QuizParams.returnTestData());
        // return;
        // ---------------- END TEST
        QuizParams.queryGet(params, (data) => successCb(data.data), errCb);
    }

    static saveResult(regCode, eventId, answers ) {
        const params = {
            "p": "api",
            "op": "save-quiz",
            "id":regCode,
            "event_id":eventId,
            ...answers
        };
        QuizParams.queryGet(params, (data) => {}, ()=>{alert("Post results error!")});
    }

    static paramNames() {
        return [
            'event_name',
            'logo',
            'questions'
        ];
    }

    static returnTestData() {
        return {
            "event_name": "Test name",
            "logo": "/images/logo.png",
            "questions": [{
                question: "Скільки мільонів років тому жили динозаври?",
                name: "question1",
                time: 10,
                options: [
                    "10", "100", "300", "1000"
                ]
            },{
                question: "В якому році почалась друга світова війна?",
                name: "question2",
                time: 5,
                options: [
                    "1933", "1939", "1941"
                ]
            },{
                question: "Что есть за обедом кракадил?",
                name: "question3",
                time: 7,
                options: [
                    "слоника", "удава", "попугая"
                ]
            }]
        }
    }
}

